import { StatePreV2, StateV2 } from './2_migrate_assekuranztarif.interface';

export const migrateAssekuranztarif = (previousState: StatePreV2, newVersion: number): StateV2 => {
  const newState = {
    ...previousState,
    version: newVersion,
    versicherungsnehmer: {
      ...previousState.versicherungsnehmer,
      isAssekuranztarif: previousState.versicherungsnehmer.isFinanzdienstleistertarif,
    },
  };
  delete newState.versicherungsnehmer.isFinanzdienstleistertarif;
  return newState;
};
